export const highlightPresetRegistry = {
  '2': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
  '3': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#7765af', textColor: '#ffffff' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
  '4': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#9587c7', textColor: '#000000' },
    { fillColor: '#584596', textColor: '#ffffff' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
  '5': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#a598d3', textColor: '#000000' },
    { fillColor: '#7765af', textColor: '#ffffff' },
    { fillColor: '#49358a', textColor: '#ffffff' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
  '6': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#afa3db', textColor: '#000000' },
    { fillColor: '#8979bd', textColor: '#000000' },
    { fillColor: '#6452a0', textColor: '#ffffff' },
    { fillColor: '#402c83', textColor: '#ffffff' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
  '7': [
    { fillColor: '#D7D0F8', textColor: '#000000' },
    { fillColor: '#b5aadf', textColor: '#000000' },
    { fillColor: '#9587c7', textColor: '#000000' },
    { fillColor: '#7765af', textColor: '#ffffff' },
    { fillColor: '#584596', textColor: '#ffffff' },
    { fillColor: '#39267e', textColor: '#ffffff' },
    { fillColor: '#150565', textColor: '#ffffff' },
  ],
} as const;
